import constants from 'js/modules/constants';

const isSandals = (window._app.brand === constants.brand.sandals);
const isBeaches = (window._app.brand === constants.brand.beaches);

// const {isSandals, isBeaches}  = window._app.brandOptions;

const getBrandName = () => {

  let brand = '';

  switch(window._app.brand) {
    case constants.brand.beaches:
      brand = 'beaches';
      break;
    default:
      brand = 'sandals';
  }

  return brand;

  // return window._app.brandOptions.longName;

};

export {
  isSandals,
  isBeaches,
  getBrandName,
};



// WEBPACK FOOTER //
// ./js/modules/brand.js